import PropTypes from "prop-types";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0
});

const Currency = ({ children }) => {
  return formatter.format(children);
};

Currency.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default Currency;
